import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  DateField,
  NumberField,
  FunctionField,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';
import { Printing } from '../../types';
import { calculatePrintingProgress, NUMBER_FORMATS, DATETIME_FORMAT } from '../../utils';
import { ReferenceChipField, ListActions } from '../common';

const printingFilters = [
  <TextInput key="id" source="id" label="ID" alwaysOn />,
  <ReferenceInput key="machineId" source="machineId" reference="machines" label="Machine" alwaysOn>
    <AutocompleteInput optionText="serial" />
  </ReferenceInput>,
  <TextInput key="orderId" source="orderId" label="Order ID" alwaysOn />,
];

export const PrintingList = () => {
  return (
    <List filters={printingFilters} actions={<ListActions />} sort={{ field: 'id', order: 'DESC' }}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" />
        <ReferenceField
          source="machineId"
          reference="machines"
          label="Machine"
          sortBy="machineId"
          link={false}
        >
          <ReferenceChipField labelField="serial" linkTo={(id) => `/machines/${id}/show`} />
        </ReferenceField>
        <TextField source="orderId" label="Order" />
        <TextField source="foot" />
        <FunctionField
          label="Progress"
          render={(record: Printing) => calculatePrintingProgress(record)}
          sortable={false}
        />
        <NumberField source="totalLines" label="Total Lines" />
        <DateField source="startTime" showTime options={DATETIME_FORMAT} />
        <DateField source="endTime" showTime options={DATETIME_FORMAT} />
        <NumberField
          source="expectedWeight"
          label="Expected Weight"
          options={NUMBER_FORMATS.weight}
        />
        <NumberField source="weight" options={NUMBER_FORMATS.weight} />
      </Datagrid>
    </List>
  );
};
